<template>
    <v-card style="border-radius: 1em;" class="pa-2">
        <v-card-text>
            <h1 class="mb-3" style="text-align: center;">Detalhes da Compra</h1>
            <v-layout justify-end>
                <v-btn small round  :color="cancelada ? 'error' : 'success'">{{cancelada ? 'Cancelada': 'Válida'}}</v-btn>
            </v-layout>
            <v-layout row wrap style="font-size: 1.3em;">
                <v-flex xs6 class="mb-1">ID da compra: <b>{{compra.id_compra}}</b></v-flex>
                <v-flex xs6 class="mb-1">
                    Vendedor: <b>
                        <template v-if="compra.posto">
                            {{compra.posto.nome_fantasia}}
                        </template>
                        <template v-else-if="compra.empresa_vendedora">
                            {{compra.empresa_vendedora.nome_fantasia}}
                        </template>
                        <template v-else>
                            Não Informado
                        </template>
                    </b>
                </v-flex>
                <v-flex xs6 class="mb-1">
                    Comprador: <b>
                        <template v-if="compra.comprador === 1 && compra.cliente">
                            {{compra.cliente.pessoa.nome_completo}}
                        </template>
                        <template v-else-if="compra.comprador === 2 && compra.empresa">
                            {{compra.empresa.nome_fantasia}}
                        </template>
                        <template v-else>
                            Não Informado
                        </template>
                    </b>
                </v-flex>
                <v-flex xs6 v-if="compra.posto" class="mb-1">
                    CNPJ do Vendedor: <b>
                        {{(compra.posto || compra.empresa).cnpj}}
                    </b>
                </v-flex>
                <v-flex xs6 v-if="compra.cliente || compra.empresa" class="mb-1">
                    {{compra.cliente ? 'CPF' : 'CNPJ'}} do Comprador: <b>{{compra.cliente ? compra.cliente.pessoa.cpf : compra.empresa.cnpj}}</b>
                </v-flex>
                <v-flex xs6 class="mb-1">
                    Data da Compra: <b v-if="compra.data_compra">{{compra.data_compra.split('-').reverse().join('/')}}</b>
                </v-flex>
                <v-flex xs6 class="mb-1">
                    Horário de Leitura: <b>{{compra.hora_compra ? compra.hora_compra : "Não possui"}}</b>
                </v-flex>
                <v-flex xs6 class="mb-1">
                    Foi Paga: <b>{{compra.confirmado ?  'SIM' : 'NÃO'}}</b>
                </v-flex>
                <v-flex xs6 class="mb-1">
                    Valor Total:
                        <b v-if="compra.valor_total">
                            {{compra.valor_total | currency({ fractionCount: 2 })}}
                        </b>
                        <b v-else>
                            {{compra.valor | currency({ fractionCount: 2 })}}
                        </b>
                </v-flex>
                <v-flex xs6 v-if="compra.valor" class="mb-1">
                    Valor da Pago: <b>{{compra.valor | currency({ fractionCount: 2 })}}</b>
                </v-flex>
                <v-flex xs6 v-if="compra.valor" class="mb-1">
                    Desconto: <b>{{compra.desconto}}%</b>
                </v-flex>
                <v-flex xs6 v-if="compra.tipo_pagamento" class="mb-1">
                    Tipo de pagamento: <b>{{compra.tipo_pagamento}}</b>
                </v-flex>
                <v-flex xs6 v-if="compra.nsu" class="mb-1">
                    NSU: <b>{{compra.nsu}}</b>
                </v-flex>
                <v-flex xs6 v-if="compra.metodo_pagamento" class="mb-1">
                    Pago em: <b>{{compra.metodo_pagamento === 'pospago' ? 'Estabelecimento' : 'Aplicativo' }}</b>
                </v-flex>
                <v-flex xs6 class="mb-1">
                    Código: <b>{{ compra.codigo }}</b>
                </v-flex>
                <v-flex xs6 v-if="compra.posto" class="mb-1">
                    Nome de Estabelecimento:
                    <b>
                        <template v-if="compra.posto">
                            {{compra.posto.nome_fantasia }}
                        </template>
                        <template v-else-if="compra.empresa_vendedora">
                            {{compra.empresa_vendedora.nome_fantasia }}
                        </template>
                        <template v-else>
                            Não Informado
                        </template>
                    </b>
                </v-flex>
                <v-flex xs6 v-if="compra.metodo_pagamento === 'pospago'" class="mb-1">
                    Endereço de Vendedor:
                    <b>
                        <template v-if="compra.posto">
                            {{
                                compra.posto && compra.posto.endereco ? `${compra.posto.endereco.logradouro}, Nº${compra.posto.endereco.numero} - ${compra.posto.endereco.bairro}. ${compra.posto.endereco.cidade}/${compra.posto.endereco.estado}. CEP: ${compra.posto.endereco.cep}`: 'Não informado'
                            }}
                        </template>
                        <template v-else-if="compra.empresa_vendedora">
                            {{
                                compra.empresa_vendedora && compra.empresa_vendedora.endereco ? `${compra.empresa_vendedora.endereco.logradouro}, Nº${compra.empresa_vendedora.endereco.numero} - ${compra.empresa_vendedora.endereco.bairro}. ${compra.empresa_vendedora.endereco.cidade}/${compra.empresa_vendedora.endereco.estado}. CEP: ${compra.empresa_vendedora.endereco.cep}`: 'Não informado'
                            }}
                        </template>
                        <template v-else>
                            Não Informado
                        </template>
                    </b>
                </v-flex>
                <v-flex xs6 v-if="compra.cliente" class="mb-1">
                    Endereço do comprador: <b>
                        <template v-if="compra.comprador == 1 && compra.cliente">
                            {{
                                compra.cliente && compra.cliente.pessoa && compra.cliente.pessoa.endereco ? `${compra.cliente.pessoa.endereco.logradouro}, Nº${compra.cliente.pessoa.endereco.numero} - ${compra.cliente.pessoa.endereco.bairro}. ${compra.cliente.pessoa.endereco.cidade}/${compra.cliente.pessoa.endereco.estado}. CEP: ${compra.cliente.pessoa.endereco.cep}`: 'Não informado'
                            }}
                        </template>
                        <template v-if="compra.comprador == 2 && compra.empresa">
                            {{
                                compra.empresa && compra.empresa.endereco ? `${compra.empresa.endereco.logradouro}, Nº${compra.empresa.endereco.numero} - ${compra.empresa.endereco.bairro}. ${compra.empresa.endereco.cidade}/${compra.empresa.endereco.estado}. CEP: ${compra.empresa.endereco.cep}`: 'Não informado'
                            }}
                        </template>
                        <template v-else>
                            Não Informado
                        </template>
                    </b>
                </v-flex>
                <v-flex xs6 class="mb-1">
                    Leitura Realizada: <b>{{!compra.disponivel ? 'SIM' : 'NÃO' }}</b>
                </v-flex>
                <v-flex xs6 class="mb-1">
                    Data de Leitura: <b v-if="compra.data_inativado">
                        {{compra.data_inativado.split('-').reverse().join('/')}}
                    </b>
                </v-flex>
                <v-flex xs6 v-if="!compra.disponivel" class="mb-1">
                    Horário de Leitura: <b>{{compra.hora_inativado ? compra.hora_inativado : "Não possui"}}</b>
                </v-flex>
                <v-flex xs6 v-if="compra.frentista" class="mb-1">
                    Frentista: <b>{{ compra.frentista.nome}}</b>
                </v-flex>
                <v-flex xs6 v-if="compra.funcionario" class="mb-1">
                    Funcionário: <b>{{ compra.funcionario.nome_email}}</b>
                </v-flex>
                <v-flex xs6 class="mb-1">
                    Cancelada: <b>{{ compra.cancelado ? 'SIM' : 'NÃO'}}</b>
                </v-flex>
                <v-flex xs6 class="mb-1">
                    Data de Cancelamento:
                    <b v-if="compra.data_cancelamento">
                        {{ compra.data_cancelamento.split('-').reverse().join('/') }}
                    </b>
                </v-flex>
                <v-flex xs6 class="mb-1">
                    Descrição: <b>{{ compra.descricao }}</b>
                </v-flex>
                <v-flex xs12 v-if="compra.veiculo" class="mb-1">
                    Placa do Veículo: <b>{{compra.veiculo.identificacao}}</b>
                </v-flex>
                <v-flex xs12 class="mb-1">
                    Produtos adquirido:
                    <b>
                        <template v-if="compra.combustivel">
                            Combustível-{{ compra.combustivel.nome }}
                        </template>
                        <template v-else-if="compra.pedido && compra.pedido.itens.length > 0">
                            <v-list>
                                <v-list-tile
                                    v-for="(item_pedido, index) in compra.pedido.itens"
                                    :key="index"
                                >
                                    <v-list-tile-avatar>
                                        <v-tooltip bottom>
                                            <v-icon :color="item_pedido.item.categoria.cor" slot="activator">
                                                {{ item_pedido.item.categoria.icone }}
                                            </v-icon>
                                            <span>
                                                {{ item_pedido.item.categoria.nome }}
                                            </span>
                                        </v-tooltip>
                                    </v-list-tile-avatar>
                                    <v-list-tile-context>
                                        <v-list-tile-title>
                                            {{ item_pedido.item.nome }}
                                        </v-list-tile-title>
                                        <v-list-tile-sub-title>
                                            Preço unitario: {{ item_pedido.preco_unitario }}
                                        </v-list-tile-sub-title>
                                    </v-list-tile-context>
                                </v-list-tile>
                            </v-list>
                        </template>
                        <template v-else>
                            Não Informado
                        </template>
                    </b>
                </v-flex>
            </v-layout>
        </v-card-text>
        <v-card-actions class="justify-space-around">
            <v-btn round @click="$emit('fechar')">Fechar</v-btn>
            <v-btn round color="error" @click="cancelarCompra" v-if="!compra.cancelado">Cancelar Compra</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    props: ['compra'],
    methods: {
        formatarCor (cor) {
            if (cor === null) return ''
            if (cor === undefined) return ''
            if (cor.length === 6) return `#${cor}`
            if (cor.length === 7) return cor
            if (cor.length === 9) return cor.slice(0, 7)
            else {
                let teste = parseInt(cor)
                teste = teste.toString(16)
                return `#${teste.slice(2, 8)}`
            }
        },
        cancelarCompra () {
            if (!this.cancelada) {
                this.$store.dispatch('cancelarCompra', this.compra.id_compra).then(() => {
                    this.cancelada = true
                    this.$emit('carregarCompras')
                })
            }
        }
    },
    data: () => ({
        cancelada: false
    }),
    beforeMount () {
        if (this.compra) {
            this.cancelada = this.compra.cancelado
        }
    }
}
</script>
